import './Shops.css';

import React, {useEffect, useState} from 'react';
import Shop from './shop/Shop';
import {Accordion} from 'react-accessible-accordion';
import {lang} from '../../common/baseData';

function Shops(props) {
  const sectionArr = [17901, 18700, 19017, 18227, 18432, 18900, 19018, 18891];

  function getMessage(code) {
    return props.messages.hasOwnProperty(code)
        ? props.messages[code]
        : 'Lang message not defined';
  }

  const shops = props.shops.map((shop, i) => {
    return <Shop {...shop} getMessage={getMessage} key={i} lang={lang}/>;
  });

  console.log(props)

  return (
      <>
        {
          Array.isArray(props.shops) && props.shops.length ?
              <div className="content content-page-holder shops">
                <div className="section-title">
                  <h2>{props.title}</h2>
                </div>
                <aside>
                  <Accordion allowZeroExpanded={true}>{shops}</Accordion>
                </aside>
              </div> :
              <></>
        }
      </>
  );
}

export default Shops;
